import { ANNULUS_CONDITION } from 'src/app/core/models/results/annulus-condition';
import { ConnectorFatigueLayer } from './connector-fatigue-layer.model';

export class ConnectorFatigueStructure {
  id?: number;
  title: string;
  snCurveId: number;
  anularCondition: ANNULUS_CONDITION;
  stressConcentrationFactorMean: number;
  stressConcentrationFactorAlternate: number;
  layerConfiguration: ConnectorFatigueLayer[];

  constructor(
    props = {
      id: null,
      title: '',
      snCurveId: -1,
      anularCondition: ANNULUS_CONDITION.DRY,
      stressConcentrationFactorMean: 1,
      stressConcentrationFactorAlternate: 1,
      layerConfiguration: [],
    },
  ) {
    Object.assign(this, props);
  }
}
